import { useEffect, useState } from "react";
import { useAuthSession } from "../auth/useAuthSession.ts";
import { getBrowserClient } from "../supabase/browser.ts";

export interface OwlUnpricedPick {
  id: string;
  home: string;
  away: string;
  league: string;
  kickoff_at: string;
  market: string;
  selection: string;
  price_status: "unpriced";
}

export function useOwlUnpricedPicks() {
  const { user } = useAuthSession();
  const [picks, setPicks] = useState<OwlUnpricedPick[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    if (!user) {
      setPicks([]);
      setLoading(false);
      return;
    }
    let cancelled = false;
    const refresh = async () => {
      try {
        const result = await getBrowserClient().rpc("get_owl_unpriced_picks" as never);
        if (cancelled) return;
        if (result.error) {
          setPicks([]);
          setError("Couldn't load unpriced picks.");
        } else {
          setPicks((Array.isArray(result.data) ? result.data : []) as OwlUnpricedPick[]);
          setError(null);
        }
      } catch {
        if (!cancelled) {
          setPicks([]);
          setError("Couldn't load unpriced picks.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    setLoading(true);
    void refresh();
    const timer = setInterval(() => void refresh(), 60_000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [user?.id, revision]);
  return { picks, loading, error, refetch: () => setRevision((value) => value + 1) };
}
